<template>
  <div class="col-xs-12 hidden-xs hidden-sm brands">
    <ul>
      <li><img src='@/images/vigia.jpg'/></li>
      <li><img src='@/images/vitran.jpg'/></li>
      <li><img src='@/images/viesa.jpg'/></li>
      <li><img src='@/images/gestya.jpg'/></li>
      <li><img src='@/images/coblow.jpg'/></li>
      <li><img src='@/images/rentagro.jpg'/></li>
      <li><img src='@/images/voryl.jpg'/></li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
      };
    },
    methods: {
    }
  }
</script>
<!--
position: relative;
position: fixed bottom;
solid #ececec;
-->
<style scoped>
.brands {
  position: fixed;
  left: 0;
  bottom: 0;
  min-height: 1px;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  border-top: 1px solid #E2E2E2;
  z-index: 5;
}

.brands ul {
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-around;
  list-style: none;
  padding-left: 10vw;
  padding-right: 10vw;
  padding-top: 0vw;
  margin-top: 5px;
  margin-bottom: 5px;
}

.brands ul li {
  display: inline-block;
  width: calc(100% / 6);
  text-align: center;
}

.brands img {
  margin: auto;
  display: block;
  max-width: 50%;
  max-height: 50%;
  height: auto;
}
</style>
<!--margin: 0px auto;
  padding: 0px 0;
  -->